import {Injectable} from '@angular/core';
import {NestApiProvider} from '../nest-api';
import {Observable} from 'rxjs';
import {RequestExportSocsoPDF} from './socso-report.dto';

@Injectable()
export class SocsoReportApi {
  private readonly service: string = 'payroll';
  private readonly model: string = 'socsoreport';

  constructor(
    private nestApiProvider: NestApiProvider,
  ) {
  }

  public exporttopdf(payload: RequestExportSocsoPDF): Observable<any> {
    const method: string = 'POST';
    const func: string = 'exporttopdf';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.requestBlobWithProgress(method, url, params, urlParams, body);
  }
}



// WEBPACK FOOTER //
// ./src/shared/nestjs/payroll/socso-report.api.ts